import { render, staticRenderFns } from "./EditAttrSpec.vue?vue&type=template&id=2cfbd5d8&scoped=true"
import script from "./EditAttrSpec.vue?vue&type=script&lang=js"
export * from "./EditAttrSpec.vue?vue&type=script&lang=js"
import style0 from "./EditAttrSpec.vue?vue&type=style&index=0&id=2cfbd5d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cfbd5d8",
  null
  
)

export default component.exports